import {shallowEqual, useSelector} from 'react-redux'

const currentUserIdSelector = state => state.authentication.id
export function useCurrentUserId() {
  const currentUserId = useSelector(currentUserIdSelector, shallowEqual)
  return {
    currentUserId,
  }
}
